import { render, staticRenderFns } from "./lawsuit_index.vue?vue&type=template&id=34a0e92a&scoped=true"
import script from "./lawsuit_index.vue?vue&type=script&lang=js"
export * from "./lawsuit_index.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_index.vue?vue&type=style&index=0&id=34a0e92a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a0e92a",
  null
  
)

export default component.exports